import React, { useEffect, useState, useContext } from 'react';
import { AuthContext } from '../context/AuthContext.js';
import { db } from '../firebaseConfig.js';
import { collection, getDocs, query, where, doc, updateDoc, addDoc } from 'firebase/firestore';
import './Cajero.css';
import { initMercadoPago, Wallet } from '@mercadopago/sdk-react';
import axios from 'axios';

const Cajero = () => {
  const { currentUser } = useContext(AuthContext);
  const [referidos, setReferidos] = useState(0);
  const [saldo, setSaldo] = useState(0);
  const [cbuCvu, setCbuCvu] = useState('');
  const [nuevoCbuCvu, setNuevoCbuCvu] = useState('');
  const [cuentasGuardadas, setCuentasGuardadas] = useState([]);
  const [cbuRetiro, setCbuRetiro] = useState('');
  const [montoRetiro, setMontoRetiro] = useState('');
  const [mensaje, setMensaje] = useState('');
  const [montoCarga, setMontoCarga] = useState('');
  const [preferenceId, setPreferenceId] = useState(null);
  const [isLoading, setIsLoading] = useState(false);  // Nuevo estado para manejar la carga

  initMercadoPago('APP_USR-7eb36f7d-088b-43ed-ab66-22111d47606c', {
    locale: "es-AR",
  });

  const createPreference = async () => {
    try {
      setIsLoading(true);  // Inicia la carga
      const response = await axios.post("https://us-central1-apimys-8da15.cloudfunctions.net/api/create_preference", {
        title: "Saldo Apimys",
        quantity: 1,
        price: parseFloat(montoCarga),
      });
      const { id } = response.data;
      setIsLoading(false);  // Termina la carga
      return id;
    } catch (error) {
      console.log(error);
      setIsLoading(false);  // Termina la carga en caso de error
    }
  };

  const handleCargarSaldo = async () => {
    if (!montoCarga || parseFloat(montoCarga) <= 0) {
      alert("Ingresa un monto válido para cargar saldo.");
      return;
    }
    const id = await createPreference();
    setPreferenceId(id);
  };

  useEffect(() => {
    if (currentUser) {
      obtenerReferidos();
      obtenerSaldo();
      obtenerCbuCvu();
      obtenerCuentasGuardadas();
    }
  }, [currentUser]);

  const obtenerReferidos = async () => {
    try {
      const q = query(collection(db, 'users'), where('referidoPor', '==', currentUser.uid));
      const querySnapshot = await getDocs(q);
      setReferidos(querySnapshot.size);
    } catch (error) {
      console.error('Error al obtener los referidos:', error);
    }
  };

  const obtenerSaldo = async () => {
    try {
      const userDoc = await getDocs(query(collection(db, 'users'), where('uid', '==', currentUser.uid)));
      if (!userDoc.empty) {
        const userData = userDoc.docs[0].data();
        setSaldo(userData.saldo || 0);
      }
    } catch (error) {
      console.error('Error al obtener el saldo:', error);
    }
  };

  const obtenerCbuCvu = async () => {
    try {
      const userDoc = await getDocs(query(collection(db, 'users'), where('uid', '==', currentUser.uid)));
      if (!userDoc.empty) {
        const userData = userDoc.docs[0].data();
        setCbuCvu(userData.cbuCvu || '');
      }
    } catch (error) {
      console.error('Error al obtener el CBU/CVU:', error);
    }
  };

  const obtenerCuentasGuardadas = async () => {
    try {
      const userDoc = await getDocs(query(collection(db, 'users'), where('uid', '==', currentUser.uid)));
      if (!userDoc.empty) {
        const userData = userDoc.docs[0].data();
        setCuentasGuardadas(userData.cuentasGuardadas || []);
      }
    } catch (error) {
      console.error('Error al obtener las cuentas guardadas:', error);
    }
  };

  const guardarCbuCvu = async () => {
    try {
      const userRef = doc(db, 'users', currentUser.uid);
      await updateDoc(userRef, {
        cbuCvu: nuevoCbuCvu,
        aliascvucbu: nuevoCbuCvu,
        cuentasGuardadas: [...cuentasGuardadas, nuevoCbuCvu],
      });
      setCuentasGuardadas((prev) => [...prev, nuevoCbuCvu]);
      setNuevoCbuCvu('');
      setMensaje('Datos guardados correctamente.');

      // Limpia el mensaje después de 3 segundos (opcional)
      setTimeout(() => setMensaje(''), 3000);
    } catch (error) {
      console.error('Error al guardar el CBU/CVU:', error);
      setMensaje('Hubo un error al guardar el CBU/CVU.');
      setTimeout(() => setMensaje(''), 3000);
    }
  };

  const procesarRetiro = async () => {
    if (!cbuRetiro || !montoRetiro) {
      alert('Debes seleccionar una cuenta y un monto válido.');
      return;
    }
    if (montoRetiro > saldo) {
      alert('El monto no puede superar el saldo disponible.');
      return;
    }

    try {
      const retiro = {
        uid: currentUser.uid,
        monto: parseFloat(montoRetiro),
        cbuCvuDestino: cbuRetiro,
        estado: 'En proceso',
        fecha: new Date(),
      };

      await addDoc(collection(db, 'retiros'), retiro);

      setSaldo(saldo - montoRetiro);
      setMontoRetiro('');
      setCbuRetiro('');
      alert('Retiro en proceso. Será revisado por la administración.');
    } catch (error) {
      console.error('Error al procesar el retiro:', error);
      alert('Hubo un error al procesar el retiro.');
    }
  };

  return (
    <div className="cajero_container">
      <h2 className="cajero_title">Cajero</h2>

      <div className="cajero_section-float">
        <div className="cajero_section float-a">
          <h3 className="cajero_subtitle">Usuarios Referidos</h3>
          <p className="cajero_info">Cantidad de referidos: {referidos}</p>
        </div>

        <div className="cajero_section float-a">
          <h3 className="cajero_subtitle">Saldo Disponible</h3>
          <p className="cajero_info">Saldo actual: ${saldo}</p>
        </div>
      </div>

      <div className="cajero_section">
        <h3 className="cajero_subtitle">Carga de Saldo</h3>
        <input
          type="number"
          className="cajero_input"
          placeholder="Monto a cargar"
          value={montoCarga}
          onChange={(e) => setMontoCarga(e.target.value)}
        />
        <button className="cajero_button" onClick={handleCargarSaldo} disabled={isLoading}>
          {isLoading ? 'Cargando...' : 'Cargar saldo con Mercado Pago'}
        </button>
        {preferenceId && <Wallet initialization={{ preferenceId: preferenceId }} />}
      </div>

      <div className="cajero_section">
        <h3 className="cajero_subtitle">ALIAS, CBU o CVU</h3>
        <p className="cajero_info">Cuenta Actual: {cbuCvu || 'No cargado'}</p>
        <input
          type="text"
          className="cajero_input"
          placeholder="Ingresar nuevo CBU/CVU"
          value={nuevoCbuCvu}
          onChange={(e) => setNuevoCbuCvu(e.target.value)}
        />
        <button className="cajero_button" onClick={guardarCbuCvu}>
          Guardar CBU/CVU
        </button>
        {mensaje && <p style={{ color: mensaje.includes('error') ? 'red' : 'green' }}>{mensaje}</p>}
      </div>

      <div className="cajero_section">
        <h3 className="cajero_subtitle">Retirar Saldo</h3>
        <select
          className="cajero_input"
          value={cbuRetiro}
          onChange={(e) => setCbuRetiro(e.target.value)}
        >
          <option value="">Seleccionar cuenta</option>
          {cuentasGuardadas.map((cuenta, index) => (
            <option key={index} value={cuenta}>
              {cuenta}
            </option>
          ))}
        </select>
        <input
          type="number"
          className="cajero_input"
          placeholder="Monto a retirar"
          value={montoRetiro}
          onChange={(e) => setMontoRetiro(e.target.value)}
        />
        <button className="cajero_button" onClick={procesarRetiro}>
          Retirar
        </button>
      </div>
    </div>
  );
};

export default Cajero;
